export const messages = {
  lang: "fr",
  dateLocale: "fr-FR",
  loading: "Chargement des créneaux...",
  empty: "Aucun créneau disponible pour le moment.",
  emptyDate: "Aucun créneau disponible pour cette date.",
  appointmentTitle: "Rendez-vous",
  timezone: "Fuseau horaire",
  tzHourOf: "heure de",
  tzAt: "à",
  chooseDate: "Choisissez un jour",
  chooseSlot: "Quelle heure vous convient ?",
  slotsFor: "Horaires du",
  pickDayFirst: "Choisissez un jour pour voir les horaires disponibles.",
  slotAvailable: "Disponible",
  daySlotsOne: "{count} créneau",
  daySlotsMany: "{count} créneaux",
  formTitle: "Vos informations",
  changeSlot: "Modifier",
  back: "Retour",
  dateLabel: "Date",
  name: "Nom",
  email: "Email",
  phone: "Téléphone",
  message: "Message",
  optional: "facultatif",
  fieldNameRequired: "Indiquez votre nom.",
  fieldEmailInvalid: "Indiquez une adresse email valide.",
  fieldPhoneRequired: "Indiquez un numéro de téléphone.",
  fieldMessageRequired: "Indiquez un message.",
  privacyTitle: "Confidentialité",
  privacyDefaultNotice: "Vos données sont utilisées uniquement pour traiter cette demande de rendez-vous.",
  privacyPolicyLabel: "Consulter la politique de confidentialité",
  submit: "Réserver le rendez-vous",
  submitting: "Réservation...",
  confirmationTitle: "Rendez-vous confirmé",
  confirmationIntro: "Votre créneau est réservé.",
  confirmationNext: "Vous recevrez les détails par email si les notifications sont activées.",
  // Réponse habituelle de l'API (status « pending_confirmation ») : la demande
  // n'est validée qu'après le clic sur le lien reçu par e-mail.
  pendingTitle: "Confirmez votre rendez-vous",
  pendingIntro: "Votre demande est enregistrée. Pour la valider, cliquez sur le lien de confirmation que nous venons de vous envoyer par email.",
  pendingNext: "Sans confirmation, le créneau est libéré automatiquement. Pensez à regarder vos courriers indésirables.",
  validation: "Vérifiez les champs signalés.",
  network: "Service momentanément indisponible. Réessayez plus tard.",
  SLOT_UNAVAILABLE: "Ce créneau n'est plus disponible. Choisissez-en un autre.",
  VALIDATION_ERROR: "Certaines informations sont invalides. Vérifiez le formulaire.",
  CALENDAR_ERROR: "Les disponibilités ne peuvent pas être confirmées pour le moment.",
  EMAIL_ERROR: "Le rendez-vous est enregistré, mais la notification n'a pas pu être envoyée.",
  INTERNAL_ERROR: "Une erreur technique est survenue. Réessayez plus tard.",
  TENANT_NOT_FOUND: "Ce service de réservation n'est pas disponible.",
  RATE_LIMITED: "Trop de tentatives. Patientez un instant puis réessayez.",
  MISSING_PUBLISHABLE_KEY: "Configuration du widget incomplète (clé manquante).",
  INVALID_PUBLISHABLE_KEY: "Configuration du widget invalide (clé refusée).",
  KEY_TENANT_MISMATCH: "Configuration du widget invalide (clé d'un autre compte).",
  ORIGIN_NOT_ALLOWED: "Ce site n'est pas autorisé à afficher ce module de réservation."
};
